import { useEffect, useState, useRef } from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { TextAreaInput1, TextInput } from '../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import GoBack from '../../components/back/GoBack'
import ErrorComponent from '../../components/ErrorComponent'
import { Select } from 'antd'
import { batch, useSelector } from 'react-redux'
import { UpdateClassBookingService, UpdatePersonalTrainingSubscriptionTeacherService } from '../../services/class_booking/classBookingServices'
import OfflineCustomerMenu from './OfflineCustomerMenu'
import { CreateClientOfflineService,UpdateClientService,GetCheckClientAlreadyExistService } from '../../services/ClientServices'
import { GetClassRoomService } from '../../services/admin/ClassRoomServices'
import { GetCityListService } from '../../services/admin/CityListServices'
import {BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'
import { UploadUserFile } from '../../services/AuthServices'
import Uploader from '../../components/Uploader';
import logo from '../../../folder/images/app_logo.png'
import html2canvas from 'html2canvas'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import '@fontsource/bebas-neue/400.css'
import '@fontsource/dancing-script/700.css'
import { FiBookOpen, FiGlobe, FiMapPin, FiPhone, FiTarget, FiTrendingUp } from 'react-icons/fi'
import { AiOutlineClose } from 'react-icons/ai'
import { CreateInvoiceService } from '../../services/admin/InvoiceServices'
import moment from 'moment'
import { GetFilterStandardDashboardService } from '../../services/DashboardServices'
import { GetClassStreamService } from '../../services/admin/StudentStreamServices'
import { GetFileStandardService } from '../../services/admin/FileStandardServices'
import { GetStudentBoardService } from '../../services/admin/StudentBoardServices'
import { getGstBreakup, sumGstBreakup, amountInWords, DEFAULT_SAC_CODE, COMPANY_GSTIN, PLACE_OF_SUPPLY, SUPPLY_TYPE, RECIPIENT_GSTIN } from '../../helpers/gstHelpers'

function OfflineCustomerCE() {

  const roles = useSelector(state=>state.Auth.roles)
  const {state} = useLocation()
  
  const [data, setdata] = useState({name: '', mobile: '', email: '', city:'', is_active:true, classInfo: '',class_room:'',remarks:'',converted_to_offline:false,not_converted_to_offline:false,mode_type:'',photo:'',studentId:'',fees_end_date:'',joining_date:'',standard:'',section_board:'',stream:'',sub_stream:''});
  const [error, seterror] = useState({teacher: '', batch: '', class: '', students: '',class_room:'',remarks:'',mode_type:'',photo:'',studentId:'',fees_end_date:'',joining_date:'',standard:'',section_board:'',stream:'',sub_stream:''});

  const canEditCity = roles?.includes('admin') || roles?.includes('salesExecutive')
  const [cityOptions, setcityOptions] = useState([])

  const [classRoomList, setclassRoomList] = useState([])
  const [type, settype] = useState('') // 1 for poster and 2 for fees bill
  const [feeBillItems, setfeeBillItems] = useState([{ id: 1, line_item: 'Tuition Fee', duration: '', price: '' }])
  const [feeBillMeta, setfeeBillMeta] = useState({ payment_date: '' })
  const [captureImageSrc, setcaptureImageSrc] = useState('')
  const [signatureImageSrc, setsignatureImageSrc] = useState('')
  const signatureImageUrl = 'https://myleadsconsolebucket.s3.ap-south-1.amazonaws.com/public/uploads/fees_report.png'
  const [signatureText] = useState(() => {
   const signatures = ['My Academy Partner']
    return signatures[Math.floor(Math.random() * signatures.length)]
  })
  const [sqlDBDataExist, setsqlDBDataExist] = useState(false)
  const posterRef = useRef(null)
  const receiptRef = useRef(null)

  const [paymentMode, setpaymentMode] = useState('Cash')

  const [filterStandard, setfilterStandard] = useState([])
  const [filterSectionBoard, setfilterSectionBoard] = useState([])
  const [stream, setstream] = useState([])
  const [substream, setsubstream] = useState([])

   const classes = [
    "1st Standard",
    "2nd Standard",
    "3rd Standard",
    "4th Standard",
    "5th Standard",
    "6th Standard",
    "7th Standard",
    "8th Standard",
    "9th Standard",
    "10th Standard",
    "11th Standard",
    "12th Standard",
  ];

  const mode_type = ['Online', 'Offline']

  const navigate = useNavigate();

  useEffect(() => {

    if (state?._id !== null && state?._id !== undefined) {
      getOptions(state?.stream?._id)
      let d = state 
      let passData = {
        ...d,
        class_room:{label:d?.class_room?.label,value:d?.class_room?._id},
        fees_end_date:d?.fees_end_date ? d?.fees_end_date?.split('T')[0] : '',
        joining_date:d?.joining_date ? d?.joining_date?.split('T')[0] : '',
        standard:d?.standard ? {label:d?.standard?.label,value:d?.standard?._id} : '',
        section_board:d?.section_board ? {label:d?.section_board?.label,value:d?.section_board?._id} : '',
        stream:d?.stream ? {label:d?.stream?.label,value:d?.stream?._id} : '',
        sub_stream:d?.sub_stream ? {label:d?.sub_stream?.label,value:d?.sub_stream?._id} : ''
      }
      setdata(passData)
    
    }else{
      getOptions(null)
    }

  }, [state])

  const formatStreams = (data, streamId) => {
    const parents = data.filter(item => !item.parent_stream);

    if(streamId !== null && streamId !== undefined){
    let substream =  data?.filter(item => item.parent_stream === streamId)?.map((child) => 
        ({
          label: child.label,
          value: child._id,
        })
      )
      setsubstream(substream)
    }

    return parents.map(parent => ({
      label: parent.label,
      value: parent._id,
      datas: data
        .filter(child => child.parent_stream === parent._id)
        .map(child => ({
          label: child.label,
          value: child._id,
        })),
    }));
  };

  async function getOptions(streamId){
   const response = await GetFileStandardService()
   const response1 = await GetClassStreamService()
   const response2 = await GetStudentBoardService()
   setfilterStandard(response?.data?.datas?.map((d)=>({label:d?.label,value:d?._id})))
   setstream(formatStreams(response1?.data?.datas,streamId))
   setfilterSectionBoard(response2?.data?.datas?.map((d)=>({label:d?.name,value:d?._id})))
  }

  useEffect(()=>{
    async function loadCities(){
      const response = await GetCityListService()
      const cities = (response?.data?.datas?.[0]?.datas || '').split(',').map((c)=>c.trim()).filter(Boolean)
      setcityOptions(cities?.map((c)=>({label:c,value:c})))
    }
    loadCities()
  },[])

  useEffect(() => {
    let active = true

    async function loadCaptureImage() {
      if (!data?.photo) {
        setcaptureImageSrc('')
        return
      }

      const remoteUrl = `${process.env.REACT_APP_AWS_IMAGE_URL}${data.photo}`
      try {
        const response = await fetch(remoteUrl, { mode: 'cors' })
        const blob = await response.blob()
        const reader = new FileReader()
        reader.onloadend = () => {
          if (active) {
            setcaptureImageSrc(reader.result || remoteUrl)
          }
        }
        reader.readAsDataURL(blob)
      } catch (error) {
        if (active) {
          setcaptureImageSrc(remoteUrl)
        }
      }
    }

    loadCaptureImage()

    return () => {
      active = false
    }
  }, [data?.photo])

  useEffect(() => {
    let active = true

    async function loadSignatureImage() {
      try {
        const response = await fetch(signatureImageUrl, { mode: 'cors' })
        const blob = await response.blob()
        const reader = new FileReader()
        reader.onloadend = () => {
          if (active) {
            setsignatureImageSrc(reader.result || signatureImageUrl)
          }
        }
        reader.readAsDataURL(blob)
      } catch (error) {
        if (active) {
          setsignatureImageSrc(signatureImageUrl)
        }
      }
    }

    loadSignatureImage()

    return () => {
      active = false
    }
  }, [signatureImageUrl])



  async function handlechange(e) {
    let {name,value} = e.target
    setdata({ ...data, [name]: value })
    seterror({ ...error, [name]: '' })
  }

  async function searchData(val,type){
      if(type === 'class_room'){
        const response = await GetClassRoomService(1, val, '', '')
        let arr = []
        response?.data?.datas?.forEach((d)=>{
          arr?.push({label:`${d?.name} [${d?.label}]`,value:d?._id})
        })
        setclassRoomList(arr)
      }
  
  }


  async function UploadFile(e,name){
      const fd = new FormData()
      fd.append('file',e)
      const response = await UploadUserFile(fd)
      setdata({...data,[name]:response?.data?.data})
  
    }


  async function submitform() {
    if (!data.name) {
      seterror({ ...error, name: 'This field is required *' })
    }else if(!data.mobile) {
      seterror({ ...error, mobile: 'This field is required *' })
    }else if(!data.standard) {
      seterror({ ...error, standard: 'This field is required *' })
    }else if(!['1st PUC', '2nd PUC']?.includes(data?.standard?.label) && !data.section_board) {
      seterror({ ...error, section_board: 'This field is required *' })
    }else if(['1st PUC', '2nd PUC']?.includes(data?.standard?.label) && !data.stream) {
      seterror({ ...error, stream: 'This field is required *' })
    }else if(['1st PUC', '2nd PUC']?.includes(data?.standard?.label) && !data.sub_stream) {
      seterror({ ...error, sub_stream: 'This field is required *' })
    }else if(!data.class_room) {
      seterror({ ...error, class_room: 'This field is required *' })
    }else if(!data.mode_type) {
      seterror({ ...error, mode_type: 'This field is required *' })
    }else {
       if((data?._id !== null && data?._id !== undefined) || (state?._id !== null && state?._id !== undefined)){
        let sendData = { ...data }
        if(data?.class_room){
         sendData['class_room'] = data?.class_room?.value
        }
        if(data?.standard){
         sendData['standard'] = data?.standard?.value
        }else{
          delete sendData.standard
        }

        if(data?.section_board){
         sendData['section_board'] = data?.section_board?.value
        }else{
          delete sendData.section_board
        }

        if(data?.stream){
         sendData['stream'] = data?.stream?.value
        }else{
          delete sendData.stream
        }
        if(data?.sub_stream){
         sendData['sub_stream'] = data?.sub_stream?.value
        }else{
          delete sendData.sub_stream
        }
        sendData["id"] = data?._id || state?._id
        const response = await UpdateClientService(sendData,data?._id || state?._id)
        if (response.status === 200) {
          navigate(-1)
          toast.success('Offline Student Info Updated Successfully')
        }else{
          toast.error(response?.data?.message || 'Something went wrong')
        }
      }
    else{
       let sendData = { ...data }
        if(data?.class_room){
         sendData['class_room'] = data?.class_room?.value
        }
        if(data?.standard){
         sendData['standard'] = data?.standard?.value
        }else{
          delete sendData.standard
        }

        if(data?.section_board){
         sendData['section_board'] = data?.section_board?.value
        }else{
          delete sendData.section_board
        }

        if(data?.stream){
         sendData['stream'] = data?.stream?.value
        }else{
          delete sendData.stream
        }
        if(data?.sub_stream){
         sendData['sub_stream'] = data?.sub_stream?.value
        }else{
          delete sendData.sub_stream
        }
        sendData['added_type'] = 'Manual'

         const response = await CreateClientOfflineService(sendData)
        if (response.status === 201) {
          navigate(-1)
          toast.success('Offline Student Info Created Successfully')
        }else{
          toast.error(response?.data?.message || 'Something went wrong')
        }

    }
   }
  }

  async function handleSelect(e,e1){
    if(e1 === 'classInfo'){
      setdata({...data,classInfo:e})
      seterror({...error,classInfo:''})
    }

    if(e1 === 'mode_type'){
      setdata({...data,mode_type:e})
      seterror({...error,mode_type:''})
    }

    if(e1 === 'class_room'){
      setdata({...data,class_room:classRoomList?.find((c)=>c?.value === e)})
      seterror({...error,class_room:''})
    }

    if(e1 === 'standard'){
      setdata({...data,standard:filterStandard?.find((c)=>c?.value === e)})
      seterror({...error,standard:''})
    }

    if(e1 === 'section_board'){
      setdata({...data,section_board:filterSectionBoard?.find((c)=>c?.value === e)})
      seterror({...error,section_board:''})
    }

    if(e1 === 'stream'){
     setdata({...data,stream:stream?.find((c)=>c?.value === e),sub_stream:''})
     setsubstream(stream?.find((c)=>c?.value === e)?.datas || [])
     seterror({...error,stream:'',sub_stream:''})
    }

    if(e1 === 'sub_stream'){
     setdata({...data,sub_stream:substream?.find((c)=>c?.value === e)})
     seterror({...error,stream:'',sub_stream:''})
    }

  }

  function handleFeeBillChange(e) {
    const { name, value } = e.target
    setfeeBillMeta({ ...feeBillMeta, [name]: value })
  }

  function handleFeeItemChange(index, field, value) {
    setfeeBillItems((currentItems) => currentItems.map((item, itemIndex) => {
      if (itemIndex !== index) {
        return item
      }

      return { ...item, [field]: value }
    }))
  }

  function addFeeItem() {
    setfeeBillItems((currentItems) => ([
      ...currentItems,
      { id: Date.now(), line_item: '', duration: '', price: '' }
    ]))
  }

  function removeFeeItem(index) {
    setfeeBillItems((currentItems) => currentItems.length === 1 ? currentItems : currentItems.filter((_, itemIndex) => itemIndex !== index))
  }

  async function handleDownloadCard(ref, fileName) {
    if (!ref?.current) {
      toast.error('Template is not ready for download')
      return
    }

    const canvas = await html2canvas(ref.current, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff'
    })

    const url = canvas.toDataURL('image/png')
    const link = document.createElement('a')
    link.href = url
    link.download = `${fileName}.png`
    link.click()
  }

  async function downloadReport(ref, fileName, format = 'png') {
    try {
      if (!ref?.current) {
        toast.error('Report template is not ready for download')
        return
      }

      const loadingToast = toast.loading('Preparing your report for download...')
      
      const canvas = await html2canvas(ref.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false,
        allowTaint: true
      })

      toast.dismiss(loadingToast)

      if (format === 'png') {
        const url = canvas.toDataURL('image/png')
        const link = document.createElement('a')
        link.href = url
        link.download = `${fileName}_${new Date().toISOString().split('T')[0]}.png`
        link.click()
        toast.success('Report downloaded successfully')
      }
    } catch (error) {
      console.error('Error downloading report:', error)
      toast.error('Failed to download report. Please try again.')
    }
  }

  const parseAmount = (value) => {
    const amountValue = Number(value || 0)
    return Number.isNaN(amountValue) ? 0 : amountValue
  }

  const feeBillTotal = feeBillItems.reduce((total, item) => total + parseAmount(item?.price), 0)
  const studentImage = data?.photo ? `${process.env.REACT_APP_AWS_IMAGE_URL}${data?.photo}` : ''
  const displayImage = captureImageSrc || studentImage
  const amountText = (value) => parseAmount(value).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  const invoiceSeed = String(state?._id || data?.mobile || '001').replace(/[^a-zA-Z0-9]/g, '').slice(-4).toUpperCase() || '001'
  // const invoiceNo = `MyAcademy/2026/${invoiceSeed}`
  const receiptNo = String(feeBillItems.length).padStart(4, '0')

  const [invoiceData,setinvoiceData] = useState(null)

  // Always derive the preview from the live form fields so it never drifts from what's currently typed
  const invoiceFeeItems = feeBillItems
  const gstTotals = sumGstBreakup(invoiceFeeItems)
  const invoiceGrandTotal = feeBillTotal

  async function generateInvoice(){
     if(feeBillItems?.length === 0){ 
       toast.error('Please add at least one fee item to generate invoice')
       return
     }
     
     if(!feeBillMeta?.payment_date){
       toast.error('Please select a payment date')
       return
     }
     
     const hasValidItems = feeBillItems.every(item => item.line_item && item.price)
     if(!hasValidItems){
       toast.error('All fee items must have particulars and amount')
       return
     }
     
     try {
       const loadingToast = toast.loading('Generating invoice...')
       const response = await CreateInvoiceService({
         customer:data?._id,
         payment_date:feeBillMeta?.payment_date,
         fee_details:feeBillItems,
         total_amount:feeBillTotal,
         payment_mode:paymentMode
       })
       
       toast.dismiss(loadingToast)
       
       if(response?.status === 201){
        setinvoiceData(response?.data?.datas)
        toast.success('Invoice generated successfully')
       }else{
        toast.error(response?.data?.message || 'Something went wrong while generating invoice')
       }
     } catch (error) {
       console.error('Error generating invoice:', error)
       toast.error('Failed to generate invoice. Please try again.')
     }
  }

  async function checkDataExist(){
   const response = await GetCheckClientAlreadyExistService({mobile:data?.mobile})
   if(response?.status === 200 && response?.data?.exists){
    if(response?.data?.realDBData === null){
       toast.error('Data does not exist in the real database MySql.')
       setsqlDBDataExist(false)
    }else{
       setsqlDBDataExist(true)
    }
    let d = response?.data?.data
    setdata({
     ...data,
     _id: d?._id || '',
     name: d?.name || '',
     mobile: d?.mobile || '',
     email: d?.email || '',
     city: d?.city || '',
     classInfo: d?.classInfo || '',
     class_room: d?.class_room || '',
     remarks: d?.remarks || '',
     converted_to_offline: d?.converted_to_offline || false,
     not_converted_to_offline: d?.not_converted_to_offline || false,
     mode_type: d?.mode_type || '',
     photo: d?.photo || '',
     studentId: d?.studentId || '',
     fees_end_date: d?.fees_end_date || '',
     joining_date: d?.joining_date || '',
     standard: d?.standard ?  {label: d?.standard?.label ,value: d?.standard?._id} : '',
     section_board: d?.section_board ? {label: d?.section_board?.label ,value: d?.section_board?._id} : '',
     stream: d?.stream ? {label: d?.stream?.label ,value: d?.stream?._id} : '',
     subStream: d?.subStream ? {label: d?.subStream?.label ,value: d?.subStream?._id} : ''
    })
    toast.success('Data loaded successfully from the server.')
   }else{
    toast.error('Data does not exist in the database.')
   }
  }

  return (
    <div className='md:flex w-full md:max-h-screen min-h-[100vh]'>

   
     
      <div>
      <OfflineCustomerMenu />
      </div> 
      <div className='mb-5 w-full h-full'>
      <div className='md:flex w-full'>  
        <div className='sm:w-full relative lg:w-[300px] px-4 pt-5' >


          <GoBack />

         

          {/* <AudioRecorder /> */}




          <h6 className='font-bold'>{(state?._id !== null && state?._id !== undefined) ? 'Edit' : 'Add'} Offline Student Info</h6>
          <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b>Offline Student details</b> assign to you!.</h6>


          <TextInput
            mandatory={true}
            label={'Mobile'}
            variant="standard"
            name="mobile"
            type="text"
            error={error.mobile}
            value={data.mobile}
            handlechange={handlechange}
            handleBlur={(e) => {
              const mobile = e.target.value.trim();
              if (mobile.length === 10 && !sqlDBDataExist) {
                checkDataExist();
              }
            }}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />
            
            {data?.mobile && 
            <div className='flex items-center justify-between bg-slate-100 p-2 rounded mt-2'>
              <h6 className='text-[11px] mb-1 mt-2'>Click on to check the data exist in server <br></br> <span className='text-blue-500 cursor-pointer underline' onClick={checkDataExist}>Load Data</span></h6>
            </div>}

         <Uploader error={error?.photo} name="photo" required={false} label={'Photo'} image={data?.photo}  setimagefunc={(e)=>{UploadFile(e,'photo');seterror({...error,photo:''})}}  removeimageuploadfunc = {()=>{setdata({...data,photo:''});seterror({...error,photo:''})}} />



        <TextInput
            mandatory={true}
            label={'Name'}
            variant="standard"
            name="name"
            type="text"
            // readOnly={(roles?.includes('admin') || state?._id == undefined)}
            error={error.name}
            value={data.name}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />


           


             {/* <TextInput
            mandatory={false}
            label={'Email'}
            variant="standard"
            name="email"
            type="text"
            error={error.email}
            value={data.email}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} /> */}


             <TextInput
            mandatory={false}
            label={'Student ID'}
            variant="standard"
            name="studentId"
            type="text"
            error={error.studentId}
            value={data.studentId}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />

            {canEditCity ?
            <div>
             <h6 className='text-[11px] mb-1 mt-2'>City </h6>
                <Select
                  showSearch
                  value={data.city || null}
                  options={cityOptions}
                  filterOption={(input,option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  onChange={(v)=>{setdata({...data,city:v});seterror({...error,city:''})}}
                  placeholder=""
                  bordered={false}
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
                  />
            </div>
            : data?.city &&
            <h6 className='text-[11px] mb-1 mt-2'>City : <b>{data.city}</b></h6>}




            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Standard Maual Data </h6>
                <Select
                  value={data.classInfo} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  options={classes?.map((c)=>({label:c,value:c}))}
                  onChange={(e)=>handleSelect(e,'classInfo')}
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
                  />
            </div> 

            <div>
               <h6 className='text-[11px] mb-1 mt-2'>Standard </h6>
                <Select
                  value={data.standard} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  options={filterStandard}
                  onChange={(e)=>handleSelect(e,'standard')}
                  className='w-full border outline-0 focus:outline-0 border-l-4 border-l-slate-900 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
                  />
            </div>

            <ErrorComponent error={error.standard} />

            {!['1st PUC', '2nd PUC']?.includes(data?.standard?.label) &&
            <div>
               <h6 className='text-[11px] mb-1 mt-2'>Section Board </h6>
                <Select
                  value={data.section_board} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  options={filterSectionBoard}
                  onChange={(e)=>handleSelect(e,'section_board')}
                  className='w-full border outline-0 focus:outline-0 border-l-4 border-l-slate-900 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
                  />
            </div>}

            <ErrorComponent error={error.section_board} />



            {['1st PUC', '2nd PUC']?.includes(data?.standard?.label) &&
            <>
            <div>
               <h6 className='text-[11px] mb-1 mt-2'>Stream </h6>
                <Select
                  value={data.stream} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  options={stream}
                  onChange={(e)=>handleSelect(e,'stream')}
                  className='w-full border outline-0 focus:outline-0 border-l-4 border-l-slate-900 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
                  />
            </div>

            <ErrorComponent error={error.stream} />

            <div>
               <h6 className='text-[11px] mb-1 mt-2'>Sub Stream </h6>
                <Select
                  value={data.sub_stream} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  options={substream}
                  onChange={(e)=>handleSelect(e,'sub_stream')}
                  className='w-full border outline-0 focus:outline-0 border-l-4 border-l-slate-900 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
                  />
            </div>
            <ErrorComponent error={error.sub_stream} />

            </>}

             <div>
             <h6 className='text-[11px] mb-1 mt-2'>Class Room </h6>
                <Select
                  showSearch
                  value={data.class_room} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  options={classRoomList}
                  onSearch={(e)=>searchData(e,'class_room')}
                  onChange={(e)=>handleSelect(e,'class_room')}
                  className='w-full border outline-0 focus:outline-0 border-l-4 border-l-slate-900 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
                  />
            </div> 

            <ErrorComponent error={error.class_room} />

             <div>
             <h6 className='text-[11px] mb-1 mt-2'>Mode Type </h6>
                <Select
                  showSearch
                  value={data.mode_type} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  options={mode_type?.map((c)=>({label:c,value:c}))}
                  onChange={(e)=>handleSelect(e,'mode_type')}
                  className='w-full border outline-0 focus:outline-0 border-l-4 border-l-slate-900 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
                  />
            </div> 

            <ErrorComponent error={error.mode_type} />

  

        

          <TextAreaInput1 
          label={'Remarks'}
            variant="standard"
            name="offline_remarks"
            type="date"
            error={error.offline_remarks}
            value={data.offline_remarks}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }}

            />

             <TextInput
                  mandatory={false}
                  label={'Joining Date'}
                  variant="standard"
                  name="joining_date"
                  type="date"
                  error={error.joining_date}
                  value={data.joining_date}
                  handlechange={handlechange}
                  placeholder=""
                  InputLabelProps={{
                    style: { color: '#fff', },
              }} />

            {(data?.joining_date && state?._id !== undefined) &&
            <TextInput
                  mandatory={false}
                  label={'Fees End Date'}
                  variant="standard"
                  name="fees_end_date"
                  type="date"
                  readOnly={true}
                  error={error.fees_end_date}
                  value={data.fees_end_date}
                  handlechange={handlechange}
                  placeholder=""
                  InputLabelProps={{
                    style: { color: '#fff', },
              }} />}

            <div onClick={()=>setdata({...data,converted_to_offline:!data.converted_to_offline})} className='flex items-center mt-2 mr-2'>
              {data?.converted_to_offline ?  <BiCheckboxSquare size={22} className='text-slate-800'  />  : <BiCheckbox size={22} className='text-slate-300'  /> }
              <h6 className="text-[10px] font-[600] ml-1">Converted</h6> 
            </div> 

            <div onClick={()=>setdata({...data,not_converted_to_offline:!data.not_converted_to_offline})} className='flex items-center mt-2 mr-2'>
              {data?.not_converted_to_offline ?  <BiCheckboxSquare size={22} className='text-slate-800'  />  : <BiCheckbox size={22} className='text-slate-300'  /> }
              <h6 className="text-[10px] font-[600] ml-1">Not Converted</h6> 
            </div> 

            <div onClick={()=>setdata({...data,is_active:data?.is_active === false})} className='flex items-center mt-2 mr-2'>
              {data?.is_active !== false ?  <BiCheckboxSquare size={22} className='text-slate-800'  />  : <BiCheckbox size={22} className='text-slate-300'  /> }
              <h6 className="text-[10px] font-[600] ml-1">Active</h6> 
            </div> 

         
        <div className='mt-4 flex'>
          <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE" : "ADD"} onClick={submitform} />
        </div>

    
        {(state?._id !== null && state?._id !== undefined && state?.standard)  &&
        <div className='w-full mt-10 mb-5 p-4 bg-slate-200 border border-slate-200 rounded'>
          <h6 className='text-[11px] font-[600] mb-1'>Generate Docs</h6>
          <h6 className='text-[11px] font-[400]'>Use the below section to create poster and fees bill for the candidate refeence.</h6>
          <div className='mt-4 flex-wrap gap-2 flex'>
            <ButtonFilledAutoWidth className={'mr-2'} btnName={"Generate Poster"} onClick={()=>settype(1)}  />
            <ButtonOutlinedAutoWidth btnName={"Generate Fees Bill"} onClick={()=>settype(2)}  />
          </div>
        </div>}


        </div>
        
        {type !== '' &&
        <div className='sm:w-full relative lg:w-[calc(100%-300px)] px-4 pt-5 bg-slate-100'>
          <AiOutlineClose onClick={() => settype('')} className='absolute right-2 top-2 cursor-pointer' />
          {type === 1 &&
          <div>
            <h6 className='text-[15px] font-[600] mb-1'>Poster Generation is in progress...</h6>
            <h6 className='text-[11px] font-[400]'>Click on the below button to download the generated poster.</h6>
            <div className='my-4'>
              <ButtonFilledAutoWidth btnName={'Download Poster'} onClick={() => handleDownloadCard(posterRef, 'offline-student-poster')} />
            </div>
             
            <div
              ref={posterRef}
              id="whatsapp-status-card"
              className="relative w-[360px] h-[640px] overflow-hidden bg-white border border-slate-200"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              <div className='absolute -top-[92px] -left-[152px] opacity-100 w-[250px] h-[250px] rounded-full bg-[#072A67]' />
              <div className='absolute -top-[130px] -left-[138px] w-[250px] h-[250px] rounded-full border-[12px] border-[#e5aa1f]' />
              <div className='absolute top-0 right-0 w-[110px] h-[72px] bg-gradient-to-bl from-[#e5aa1f] to-[#f7ce68] rounded-bl-[80px]' />
              <div className='absolute bottom-0 left-0 w-full h-[50px] bg-[#072A67] rounded-t-[32px]' />
              <div className='absolute bottom-0 left-0 w-full h-[10px] bg-[#e5aa1f]' />

              <div className="relative z-10 flex justify-center pt-6">
                <img src={logo} alt="appLogo" className="h-16 z-10 object-contain" />
              </div>

              <div className="text-center mt-1">
                <h3 className="text-[24px] leading-[38px] text-[#072A67]" style={{ fontFamily: 'Dancing Script, cursive' }}>
                  Welcome
                </h3>
                <h4 className='text-[16px] text-[#072A67] tracking-[0.5em] mt-2 font-[700]'>TO</h4>
                <div className='flex justify-center items-center'>
                <h1 className="text-[#072A67] text-[30px] leading-[44px]" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}>
                  MY ACADEMY
                </h1>
                <h1 className="text-[#e5aa1f] ml-1 text-[30px] leading-[44px]" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}>
                  PARTNER
                </h1>
                </div>
              </div>

              <div className="flex justify-center mt-2">
                <div className="w-[164px] h-[164px] rounded-full border-[3px] border-[#e5aa1f] p-[2px] bg-white shadow-xl">
                  <img
                    src={displayImage || ""}
                    alt=""
                    crossOrigin="anonymous"
                    className="w-full h-full rounded-full object-cover"
                  />
                </div>
              </div>

              <div className="mt-2 text-center px-5">
                <div className="bg-[#072A67] text-white h-[35px] py-1 rounded-full  px-7">
                  <h6 className='text-[22px] z-10 -mt-[8px]' style={{ fontFamily: 'Dancing Script, cursive' }}>Congratulations,</h6>
                </div>

                <h2 className="text-[24px] font-[700] text-[#072A67] mt-2 leading-[42px]">
                  {data?.name}
                </h2>

                <p className="text-slate-700 mt-1 text-[15px]">
                  Your new learning journey begins here
                </p>

                <div className="mt-1 text-[14px] font-[600] text-[#e5aa1f]">
                  {data?.classInfo}
                </div>
              </div>

              <div className="grid grid-cols-3 mt-4 px-5 text-center text-[#072A67]">
                <div>
                  <div className='flex justify-center'><FiBookOpen size={26} className='text-[#e5aa1f]' /></div>
                  <p className="font-[700] text-[13px]">Learn</p>
                  <p className='text-[11px] text-slate-600'>with Concept</p>
                </div>

                <div>
                  <div className='flex justify-center'><FiTarget size={26} className='text-[#e5aa1f]' /></div>
                  <p className="font-[700] text-[13px]">Practice</p>
                  <p className='text-[11px] text-slate-600'>with Confidence</p>
                </div>

                <div>
                  <div className='flex justify-center'><FiTrendingUp size={26} className='text-[#e5aa1f]' /></div>
                  <p className="font-[700] text-[13px]">Achieve</p>
                  <p className='text-[11px] text-slate-600'>your Goals</p>
                </div>
              </div>

              <div className="absolute right-3 top-[325px]">
                <div className="bg-[#072A67] h-[40px] text-white px-2 py-3 rounded-md border-[2px] border-[#e5aa1f] text-center">
                  <div className="text-[9px] tracking-wider -mt-[12px]">STUDENT</div>
                  <div className="font-[700] text-[11.5px]">MEMBER</div>
                </div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 text-white px-4 pb-3 pt-2">
                <div className="flex items-center justify-between text-[12px]">
                  <div className='text-left -mt-4'>
                    <div className='font-[700] text-[10px]'>My Academy Partner</div>
                    <div className='text-[#e5aa1f] font-[700] text-[13px] leading-4'>KUNDAPURA</div>
                  </div>
                  <div className='text-center text-[9px] -ml-4 -mt-4 leading-2'>
                    <div>Strong Concepts.</div>
                    <div>Regular Learning.</div>
                    <div>Bright Future.</div>
                  </div>
                  <div className='text-right -mt-4'>
                    <div className='text-[15px]' style={{ fontFamily: 'Dancing Script, cursive' }}>success story</div>
                  </div>
                </div>
              </div>
            </div>

          </div>}

          {type === 2 &&
          <div>
            <h6 className='text-[15px] font-[600] mb-1'>Fees Bill Generation is in progress...</h6>
            <h6 className='text-[11px] font-[400]'>Fill the below arguments and click download to generate the fees receipt.</h6>

            <div className='mb-4 grid md:grid-cols-3 gap-3'>
              <TextInput
                mandatory={true}
                label={'Payment Date'}
                variant="standard"
                name="payment_date"
                type="date" 
                value={feeBillMeta.payment_date}
                handlechange={handleFeeBillChange}
                placeholder=""
              />
            </div>

            <div className='mb-4 flex justify-between items-center gap-3'>
              <h6 className='text-[11px] font-[500] text-slate-700'>Add multiple fee line items, duration text, and price before downloading.</h6>
              <ButtonOutlinedAutoWidth btnName={'Add Line Item'} onClick={addFeeItem} />
            </div>

            <div className='space-y-3 mb-4 bg-white border border-slate-200 rounded-lg p-3'>
              {feeBillItems.map((item, index) => (
                <div key={item.id} className='grid grid-cols-1 md:grid-cols-4 gap-3 items-end'>
                  <TextInput
                    mandatory={false}
                    label={'Particulars'}
                    variant="standard"
                    name={`line_item_${index}`}
                    type="text"
                    value={item.line_item}
                    handlechange={(event) => handleFeeItemChange(index, 'line_item', event.target.value)}
                    placeholder=""
                  />

                  <TextInput
                    mandatory={false}
                    label={'Duration'}
                    variant="standard"
                    name={`duration_${index}`}
                    type="text"
                    value={item.duration}
                    handlechange={(event) => handleFeeItemChange(index, 'duration', event.target.value)}
                    placeholder=""
                  />

                  <TextInput
                    mandatory={false}
                    label={'Amount'}
                    variant="standard"
                    name={`price_${index}`}
                    type="number"
                    value={item.price}
                    handlechange={(event) => handleFeeItemChange(index, 'price', event.target.value)}
                    placeholder=""
                  />

                  <div className='flex justify-end'>
                    <ButtonOutlinedAutoWidth btnName={feeBillItems.length > 1 ? 'Remove' : 'Item'} onClick={() => removeFeeItem(index)} />
                  </div>
                </div>
              ))}
              <h6 className='text-[11px] font-[500] text-slate-700'>Payment Mode</h6>
                <Select
                  value={paymentMode}
                  bordered={false}
                  placeholder=""
                  onChange={(value) => setpaymentMode(value)}
                  options={['Cash', 'Online'].map((mode) => ({ label: mode, value: mode }))}
                  className='w-full border -mt-2 outline-0 focus:outline-0 bg-white focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
                  
                />
            </div>

            

            <div className='mb-4 flex gap-2'>
              {invoiceData &&
              <>
                <ButtonFilledAutoWidth btnName={'Download Report'} onClick={() => downloadReport(receiptRef, 'fees-receipt')} />
                <ButtonOutlinedAutoWidth btnName={'Download Image'} onClick={() => handleDownloadCard(receiptRef, 'offline-student-fee-receipt')} />
              </>
              }
              {invoiceData === null ?
              <ButtonOutlinedAutoWidth btnName={'Generate Invoice'} onClick={() => generateInvoice()} />
              : 
              <ButtonOutlinedAutoWidth btnName={'Reset'} onClick={() => setinvoiceData(null)} />}

            </div>

            <div className='overflow-x-auto pb-4'>
              <div ref={receiptRef} className='w-[880px] bg-white border border-slate-300 overflow-hidden' style={{ fontFamily: 'Poppins, sans-serif' }}>
                <div className='h-[14px] bg-[#072A67] relative'>
                  <div className='absolute -bottom-[2px] left-0 w-[170px] h-[22px] bg-[#e5aa1f] rounded-r-full' />
                </div>

                <div className='px-7 py-5 border-b border-slate-200'>
                  <div className='flex justify-between items-start gap-6'>
                    <div className='w-[40%]'>
                      <img src={logo} alt="appLogo" className="h-20 object-contain mb-1" />
                      <h4 className='text-[18px] leading-5 text-[#072A67] font-[700]'>My Academy Partner</h4>
                      <h4 className='text-[12px] mt-1 text-slate-700'>Smart Learning. Strong Concepts. Bright Future.</h4>
                    </div>
                    <div className='text-left border-l border-slate-300 pl-6 w-[60%]'>
                      <h2 className='text-[50px] text-[#072A67] leading-[30px]' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.03em' }}>MY ACADEMY PARTNER</h2>
                      <h4 className='text-[40px] leading-[26px] mt-2 text-[#e5aa1f]' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.08em' }}>KUNDAPURA</h4>
                      <div className='mt-5 text-[15px] text-slate-700 leading-6'>
                        <h4 className='flex items-center'><FiMapPin className='mr-2 mt-1 text-[#072A67]' />Near New Bus Stand, Kundapura</h4>
                        <h4 className='pl-7'>Udupi Dist., Karnataka - 576201</h4>
                        <h4 className='flex items-center mt-1'><FiPhone className='mr-2 text-[#072A67]' />96865 83960</h4>
                        <h4 className='flex items-center mt-1'><FiGlobe className='mr-2 text-[#072A67]' />www.myacademypartner.com</h4>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='px-7 relative bg-[#072A67] w-[95%] mx-auto my-4 rounded-[40px]  h-[50px] py-3'>
                  <div className='text-white text-center  py-2 rounded-[20px] text-[25px] -mt-[16px]' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.03em' }}>TAX INVOICE / FEE RECEIPT</div>
                </div>

                <div className='px-7 pb-4'>
                  <div className='grid grid-cols-2 gap-3 text-[15px] border border-slate-300 rounded-md p-4 bg-slate-50'>
                    <h5><span className='font-[700] text-[#072A67]'>INVOICE NO</span> : {invoiceData?.invoice_number || '-'}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>GSTIN</span> : {COMPANY_GSTIN}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>DATE</span> : {moment(invoiceData?.createdAt)?.format('LLL') || '-'}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>ACADEMIC YEAR</span> : 2026-27</h5>
                  </div>
                </div>

                <div className='px-7 pb-3'>
                  <h4 className='text-[24px] leading-7 text-[#072A67] mb-2' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}>STUDENT DETAILS</h4>
                  <div className='border border-slate-300 rounded-md p-4 grid grid-cols-2 gap-x-8 gap-y-3 text-[15px]'>
                    <h5><span className='font-[700] text-[#072A67]'>STUDENT NAME</span> : {data?.name || '-'}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>STUDENT ID</span> : {data?.studentId || '-'}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>CLASS</span> : {data?.standard?.label || '-'}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>RECIPIENT GSTIN</span> : {RECIPIENT_GSTIN}</h5>
                  </div>
                </div>

                <div className='px-7 pb-3'>
                  <h4 className='text-[24px] leading-7 text-[#072A67] mb-2' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}>GST / SUPPLY DETAILS</h4>
                  <div className='border border-slate-300 rounded-md p-4 grid grid-cols-2 gap-x-8 gap-y-3 text-[15px]'>
                    <h5><span className='font-[700] text-[#072A67]'>PLACE OF SUPPLY</span> : {PLACE_OF_SUPPLY}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>SUPPLY TYPE</span> : {SUPPLY_TYPE}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>REVERSE CHARGE</span> : No</h5>
                    <h5><span className='font-[700] text-[#072A67]'>TAX INCLUSIVE</span> : Yes - Rs. {amountText(invoiceGrandTotal)} is inclusive of GST</h5>
                  </div>
                </div>

                <div className='px-7 pb-3'>
                  <h4 className='text-[24px] leading-7 text-[#072A67] mb-2' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}>FEE DETAILS</h4>
                  <div className='border border-slate-300 rounded-md overflow-hidden'>
                    <table className='w-full border-collapse text-[13px]' style={{ tableLayout: 'auto' }}>
                      <thead>
                        <tr className='bg-[#072A67] text-white font-[700]'>
                          <th className='p-3 text-center whitespace-nowrap'>#</th>
                          <th className='p-3 text-left border-l border-white/20'>PARTICULARS</th>
                          <th className='p-3 text-center border-l border-white/20 whitespace-nowrap'>SAC</th>
                          <th className='p-3 text-center border-l border-white/20 whitespace-nowrap'>DURATION</th>
                          <th className='p-3 text-right border-l border-white/20 whitespace-nowrap'>TAXABLE VALUE</th>
                          <th className='p-3 text-center border-l border-white/20 whitespace-nowrap'>CGST</th>
                          <th className='p-3 text-center border-l border-white/20 whitespace-nowrap'>SGST</th>
                          <th className='p-3 text-right border-l border-white/20 whitespace-nowrap'>TOTAL</th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoiceFeeItems.map((item, index) => {
                          const { taxable, cgst, sgst, total } = getGstBreakup(item?.price)
                          return (
                            <tr key={item?.id || index} className='border-t border-slate-200'>
                              <td className='p-3 text-center'>{index + 1}</td>
                              <td className='p-3 border-l border-slate-200'>{item?.line_item || '-'}</td>
                              <td className='p-3 border-l border-slate-200 text-center whitespace-nowrap'>{item?.sac || DEFAULT_SAC_CODE}</td>
                              <td className='p-3 border-l border-slate-200 text-center whitespace-nowrap'>{item?.duration || feeBillMeta?.joining_date || '-'}</td>
                              <td className='p-3 border-l border-slate-200 text-right whitespace-nowrap'>₹ {amountText(taxable)}</td>
                              <td className='p-3 border-l border-slate-200 text-center whitespace-nowrap'>
                                <div>9%</div>
                                <div>₹ {amountText(cgst)}</div>
                              </td>
                              <td className='p-3 border-l border-slate-200 text-center whitespace-nowrap'>
                                <div>9%</div>
                                <div>₹ {amountText(sgst)}</div>
                              </td>
                              <td className='p-3 border-l border-slate-200 text-right font-[700] whitespace-nowrap'>₹ {amountText(total)}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                      <tfoot>
                        <tr className='bg-[#072A67] text-white font-[700] border-t border-slate-200'>
                          <td className='p-3 text-right' colSpan={5}>TOTAL</td>
                          <td className='p-3 border-l border-white/20 text-center whitespace-nowrap'>₹ {amountText(gstTotals.cgst)}</td>
                          <td className='p-3 border-l border-white/20 text-center whitespace-nowrap'>₹ {amountText(gstTotals.sgst)}</td>
                          <td className='p-3 border-l border-white/20 text-right whitespace-nowrap'>₹ {amountText(gstTotals.total)}</td>
                        </tr>
                        <tr className='border-t border-slate-200'>
                          <td className='p-3 text-right font-[700] bg-[#072A67] text-white' colSpan={7}>FINAL AMOUNT PAID</td>
                          <td className='p-3 border-l border-slate-200 text-right text-[#072A67] font-[800] bg-[#f2c14e] whitespace-nowrap'>₹ {amountText(invoiceGrandTotal)}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <div className='px-7 pb-3'>
                  <div className='border border-slate-300 rounded-md p-3 flex justify-between items-center gap-4 bg-slate-50 text-[13px]'>
                    <h5><span className='font-[700] text-[#072A67]'>Amount in Words:</span> {amountInWords(invoiceGrandTotal)}</h5>
                    <h5 className='text-slate-500 text-[11px] whitespace-nowrap'>Taxable Value + CGST + SGST = Total Invoice Value</h5>
                  </div>
                </div>

                <div className='px-7 pb-3'>
                  <h4 className='text-[25px] leading-7 text-[#072A67] mb-2' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}>PAYMENT DETAILS</h4>
                  <div className='border border-slate-300 rounded-md p-3 grid grid-cols-3 text-[13.5px]'>
                    <h5><span className='font-[700] text-[#072A67]'>PAYMENT METHOD</span><br />{invoiceData?.payment_mode ?? paymentMode}</h5>
                    {/* <h5><span className='font-[700] text-[#072A67]'>TRANSACTION ID</span><br />-</h5> */}
                    <h5><span className='font-[700] text-[#072A67]'>PAYMENT DATE</span><br />{moment(invoiceData?.payment_date)?.format('ll') || '-'}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>PAYMENT STATUS</span><br /><span className='bg-green-100 text-green-700 px-2 rounded-full text-[12px] font-[700]'>PAID</span></h5>
                  </div>
                </div>

                <div className='px-7 pb-6 grid grid-cols-2 gap-4'>
                  <div className='border border-slate-300 rounded-md p-3 text-[13px]'>
                    <h5 className='font-[700] text-[#072A67] mb-1'>IMPORTANT NOTES</h5>
                    <h5>- Fees once paid are non-refundable.</h5>
                    <h5>- Keep this tax invoice/receipt for future reference.</h5>
                  </div>
                  <div className='flex flex-col justify-end min-h-[92px]'>
                    <div className='w-full flex justify-end'>
                      <div className='w-[250px] -mt-14 text-right'>
                        <div className='border-slate-400 pt-[2px]'>
                          <img alt="sign" className='ml-10' src={signatureImageSrc || signatureImageUrl} crossOrigin="anonymous" />
                          <h5 className='text-[14px] font-[700] -mt-5 text-[#072A67] tracking-wide'>AUTHORISED SIGNATURE</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='bg-[#072A67] text-white px-7 py-4 border-t-[5px] border-[#e5aa1f]'>
                  <div className='flex justify-between items-center'>
                    <div className='text-[12px]'><span className='font-[700] text-[#e5aa1f]'>Thank You!</span> for choosing My Academy Partner</div>
                    <div className='text-right text-[12px]' style={{ fontFamily: 'Dancing Script, cursive' }}>Together, we build a brighter future.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>}

        </div>}
        
       

      
      </div>

      
      </div> 

    </div>
  )
}

export default OfflineCustomerCE